import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { useRouter } from 'next/router';
import { parseUrl } from 'query-string';
import EMAIL_CONFIRM_MUTATION from './mutation';
import { renderChildren } from '../../helpers';

const EmailConfirm = ({ modifier, errorMessage, children }) => {
  const router = useRouter();
  const { asPath } = router;

  const { query: { token, redirectUrl: setRedirectUrl } = {} } = parseUrl(asPath);
  const [displayError, setDisplayError] = useState(true);
  const [emailConfirmMutation, { loading, called }] = useMutation(EMAIL_CONFIRM_MUTATION, {
    onCompleted: ({ confirmUserEmail }) => {
      const {
        result: { extras }
      } =
        confirmUserEmail || {};
      const { redirectUrl } = extras || {};
      setDisplayError(false);
      if (redirectUrl && !setRedirectUrl) {
        router.push(`/Resolver`, `${asPath}&redirectUrl=${redirectUrl}`, { shallow: true });
      }
    }
  });

  useEffect(
    () => {
      if (token) emailConfirmMutation({ variables: { token } });
    },
    [emailConfirmMutation, token]
  );

  if ((token && !called) || loading) return null;
  const renderedChildren = renderChildren(children);

  return <>{displayError ? <span className={modifier}>{errorMessage}</span> : renderedChildren}</>;
};

EmailConfirm.propTypes = {
  modifier: PropTypes.string,
  errorMessage: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

EmailConfirm.defaultProps = {
  modifier: '',
  errorMessage: '',
  children: []
};

export default EmailConfirm;
